/**
 * «¿Cuánto te llevó?» — al entregar una pieza (Para QC) o al terminar de revisarla, el SOA pregunta cuánto trabajo real llevó.
 *
 * Es lo que corrige las horas estimadas: lo medido hasta ahora era espera, no esfuerzo. El backend avisa en la respuesta de api.patchTarea (`pedir_esfuerzo`)
 * y este módulo abre la tarjeta de EsfuerzoHost (montada en el Layout). Declarar las horas es obligatorio: la tarjeta no se puede cerrar sin cargarlas y lo que
 * quede pendiente vuelve a aparecer al abrir el SOA (GET /api/trabajo/esfuerzo-pendiente). No frena el trabajo ni el cambio de estado de la pieza.
 */
let hayHost = false;
export const registrarHostEsfuerzo = (v) => { hayHost = !!v; };

/** Abre la tarjeta. No devuelve nada que haya que esperar: el que llama sigue con lo suyo. */
export function pedirEsfuerzo(pedido) {
  if (!hayHost || typeof window === "undefined" || !pedido?.tarea_id) return;
  window.dispatchEvent(new CustomEvent("crew-pedir-esfuerzo", { detail: pedido }));
}
